<template>
  <div class="catalog">
    <div class="wrapper" :class="{ loading: isLoading }">
      <h2 class="catalog-title" ref="catalogTitle">All bikes</h2>
      <div class="catalog-filter-wrap" :class="{ 'open-mob-filter': isMobFilter }">
        <div class="btn-filter" @click="isMobFilter = !isMobFilter">Filters</div>
        <ul class="catalog-filter" :class="{ 'open-dropdown': !!isDropdown }" v-if="allFilters">
          <li v-for="(filter, key) in allFilters" :key="key">
            <div class="catalog-filter__btn" :class="{ active: isDropdown === key }" @click="openFilter(key)">
              {{ translate(key) }} <span class="plus-ic"></span>
            </div>
            <div v-if="isDropdown === key" class="catalog-dropdown">
              <button class="backBtn" @click="isDropdown = false">{{ translate(key) }}</button>
              <ul class="dropdown-grid" :class="`filter-dropdown-${key}`">
                <li v-for="(model, idx) in filter" :key="idx" :class="{ 'checkbox-color': model.image !== undefined }">
                  <input
                    :id="`${key}_${idx}`"
                    :type="['pedal_assisted', 'price'].includes(key) ? 'radio' : 'checkbox'"
                    @click="['pedal_assisted', 'price'].includes(key) ? changeRadio($event, key) : null"
                    :value="model.slug"
                    v-model="checked[key]"
                    :class="{ 'inp-group__checkbox': model.image === undefined }"
                  />
                  <label :for="`${key}_${idx}`" v-if="model.image === undefined">
                    <span class="checkbox"></span>
                    <span>{{ model.title }}</span>
                  </label>
                  <label :for="`${key}_${idx}`" v-else>
                    <img :src="model.image" :alt="model.title" />
                    {{ model.title }}
                  </label>
                </li>
              </ul>
              <button type="button" class="btn btn-sm btn-green" @click="applyFilter(key)">Apply</button>
            </div>
          </li>
          <li>
            <div class="catalog-filter__btn" :class="{ active: isDropdown === 'price' }" @click="openFilter('price')">
              {{ translate("price") }} <span class="plus-ic"></span>
            </div>
            <div v-if="isDropdown === 'price'" class="catalog-dropdown">
              <button class="backBtn" @click="isDropdown = false">{{ translate("price") }}</button>
              <div class="range-container">
                <MultiRangeSlider
                  baseClassName="multi-range-slider"
                  :min="priceMin"
                  :max="priceMax"
                  :step="1"
                  :ruler="false"
                  :label="false"
                  :preventWheel="false"
                  :minValue="priceFromValue"
                  :maxValue="priceToValue"
                  @input="UpdateValues"
                />
                <div class="range-container__val">
                  <p class="m-0">From {{ priceFromValue }}</p>
                  <p class="m-0">To {{ priceToValue }}</p>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-green mt-0" @click="setPrice()">Apply</button>
            </div>
          </li>
        </ul>
        <div class="catalog-sort">
          <div
            class="btn-sort"
            @click="
              isSort = !isSort;
              isDropdown = false;
            "
            :class="{ active: isSort }"
          >
            Sort by {{ translate(sortBy) }}
          </div>
          <div v-if="isSort" class="catalog-dropdown">
            <ul class="sort-list" v-if="sorting">
              <li v-for="(title, key) in sorting" :key="key">
                <button class="link-black" type="button" @click="setSorting(key)">{{ title }}</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="catalog-filter-result"
        v-if="Object.keys(filters).length > 0 || this.priceMin !== this.priceFrom || this.priceMax !== this.priceTo"
      >
        <ul class="catalog-filter-result__list">
          <li v-for="(values, key) in filters" :key="key">
            <div class="ui-badge ui-badge-primary">
              <span>{{ getFilterValues(key) }}</span>
              <button type="button" class="ui-badge__close" @click="clearFilter(key)"></button>
            </div>
          </li>
          <li v-if="this.priceMin !== this.priceFrom || this.priceMax !== this.priceTo">
            <div class="ui-badge ui-badge-primary">
              <span>Price {{ getPriceText() }}</span>
              <button type="button" class="ui-badge__close" @click="clearPrice()"></button>
            </div>
          </li>
          <li>
            <button type="button" class="link-black" @click="clearFilter()">Clear all</button>
          </li>
        </ul>
      </div>
      <div v-if="!!pagination && data.length > 0" class="catalog-items">
        <catalog-card v-for="item in data" :key="item.id" :item="item" :lang="lang"></catalog-card>
      </div>
      <div v-else-if="!!pagination" class="catalog-items">
        <h3>No results found</h3>
      </div>
      <pagination
        v-if="pagination"
        ref="pagination"
        :paginator="pagination"
        @onLoadMore="onLoadItems($event)"
        :show-more="true"
        :show-pagination="false"
      ></pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CatalogCard from "./CardComponent";
import Pagination from "../PaginationComponent";
import _ from "lodash";
import MultiRangeSlider from "multi-range-slider-vue";

export default {
  name: "CatalogIndex",
  props: ["lang", "trans", "value"],
  components: { CatalogCard, Pagination, MultiRangeSlider },
  data() {
    return {
      data: [],
      filters: {},
      allFilters: {},
      pagination: null,
      isDropdown: false,
      isMobFilter: false,
      isSort: false,
      isLoading: false,
      sortBy: "latest",
      sorting: {
        latest: "Latest",
        new_product: "New Product",
        price_low: "Price low to high",
        price_high: "Price high to low",
      },
      translations: {
        category: "Category",
        suspension_travel: "Suspension travel",
        pedal_assisted: "Pedal assisted",
        motor_type: "Motor",
        family: "Model",
        size: "Size",
        color: "Colour",
        price: "Price",
        latest: "latest",
        new_product: "new product",
        price_low: "price low to high",
        price_high: "price high to low",
      },
      checked: null,
      priceMin: 0,
      priceMax: 0,
      priceFrom: 0,
      priceTo: 0,
      priceFromValue: 0,
      priceToValue: 0,
    };
  },
  mounted() {
    if (typeof this.value === "undefined" || !this.value) {
      this.loadItems();
    } else {
      this.prepareItems(this.value);
    }
  },
  methods: {
    loadItems() {
      const urlParams = new URLSearchParams(window.location.search);

      var url = "/api/catalog",
        queryStr = urlParams.toString();

      if (queryStr) {
        url += "?" + queryStr.replaceAll("%5B%5D=", "[]=");
      }

      axios
        .get(url)
        .then((response) => {
          this.prepareItems(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    prepareItems(data) {
      this.data = data.data;
      this.allFilters = data.filters;
      this.priceMin = parseInt(data.min_price);
      this.priceMax = parseInt(data.max_price);
      this.priceFrom = parseInt(data.price_from);
      this.priceTo = parseInt(data.price_to);
      this.priceFromValue = parseInt(data.price_from);
      this.priceToValue = parseInt(data.price_to);
      this.pagination = {
        links: data.links,
        meta: data.meta,
        elements: data.elements,
      };

      if (this.checked === null) {
        this.checked = {
          price: null,
        };

        var urlParams = new URLSearchParams(window.location.search);

        _.each(this.allFilters, (value, key) => {
          var params = _.flattenDeep(urlParams.getAll(key).map((val) => val.split(",")));
          var checked = _.intersectionWith(_.keys(value), params, (first, second) => first === second);

          this.$set(this.checked, key, checked);

          if (checked.length) {
            this.$set(this.filters, key, checked);
          }
        });

        var sort = urlParams.get("sort");

        if (sort && this.sorting[sort]) {
          this.sortBy = sort;
        }
      }
    },
    onLoadItems(event) {
      let { data, append } = event;

      if (append) {
        data.data = [].concat(this.data, data.data);

        this.prepareItems(data);
      } else {
        this.prepareItems(data);

        window.scrollTo({
          top: this.$refs.catalogTitle.offsetTop,
          behavior: "smooth",
        });
      }
    },
    openFilter(type) {
      this.isDropdown = !this.isDropdown || this.isDropdown !== type ? type : false;
    },
    translate(key) {
      return this.translations[key] || key;
    },
    setSorting(key) {
      this.sortBy = key;
      this.isSort = false;

      this.onLoadFiltered();
    },
    setPrice() {
      this.isMobFilter = false;
      this.isDropdown = false;

      this.priceFrom = this.priceFromValue;
      this.priceTo = this.priceToValue;

      this.onLoadFiltered();
    },
    clearPrice() {
      this.priceFromValue = this.priceMin;
      this.priceToValue = this.priceMax;
      this.priceFrom = this.priceMin;
      this.priceTo = this.priceMax;

      this.onLoadFiltered();
    },
    applyFilter(key) {
      if (this.checked[key].length) {
        this.$set(this.filters, key, this.checked[key]);
      } else {
        this.$delete(this.filters, key);
      }

      this.isMobFilter = false;
      this.isDropdown = false;

      this.onLoadFiltered();
    },
    onLoadFiltered() {
      var url = "/api/catalog";

      var params = { ...this.filters };

      if (this.priceMin !== this.priceFrom) {
        params["price_from"] = this.priceFrom;
      }

      if (this.priceMax !== this.priceTo) {
        params["price_to"] = this.priceTo;
      }

      params.sort = this.sortBy;

      this.isLoading = true;

      axios
        .get(url, {
          params: params,
        })
        .then((response) => {
          if (window.history && history.replaceState) {
            var newUrl = window.location.pathname,
              queryStr = new URLSearchParams(params).toString();

            if (queryStr) {
              newUrl += "?" + queryStr.replaceAll("%5B%5D=", "[]=");
            }

            history.replaceState(null, "", newUrl);
          }

          this.prepareItems(response.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clearFilter(key = false) {
      if (!key) {
        this.filters = {};
        this.priceFromValue = this.priceMin;
        this.priceToValue = this.priceMax;
        this.priceFrom = this.priceMin;
        this.priceTo = this.priceMax;

        _.each(this.checked, (value, key) => {
          this.$set(this.checked, key, []);
        });
      } else {
        this.$delete(this.filters, key);
        this.$set(this.checked, key, []);
      }

      this.onLoadFiltered();
    },
    getFilterValues(key) {
      let filter = this.allFilters[key];

      return _.map(
        _.filter(filter, (el) => _.includes(this.filters[key], el.slug)),
        (el) => el.title,
      ).join(", ");
    },
    changeRadio(event, key) {
      var checked = this.checked[key];

      setTimeout(() => {
        event.target.checked = this.checked[key] !== checked;

        if (!event.target.checked) {
          this.$set(this.checked, key, null);
        }
      });
    },
    UpdateValues(e) {
      this.priceFromValue = e.minValue;
      this.priceToValue = e.maxValue;
    },
    getPriceText() {
      var text = "";

      if (this.priceFrom !== this.priceMin) {
        text += " from €" + this.priceFrom;
      }

      if (this.priceTo !== this.priceMax) {
        text += " to €" + this.priceTo;
      }

      return text;
    },
  },
  watch: {
    isDropdown(newValue, oldValue) {
      if (newValue !== oldValue) {
        var key = oldValue || newValue;

        this.$set(this.checked, key, this.filters[key] || []);
      }

      this.priceFromValue = this.priceFrom;
      this.priceToValue = this.priceTo;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/catalog.scss";
@import "/node_modules/multi-range-slider-vue/MultiRangeSliderBlack.css";
@import "/node_modules/multi-range-slider-vue/MultiRangeSliderBarOnly.css";
.catalog-items {
  min-height: 102px;
}

.loading {
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #ffffff, $alpha: 0.2);
    z-index: 102;
  }
}

label {
  user-select: none;
}

.range-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .fs-24 {
    color: #000;
    margin: 0 0 26px;
    @media (max-width: 992px) {
      font-size: 18px;
      line-height: 20px;
    }
  }
  &__val {
    width: 100%;
    display: flex;
    justify-content: space-between;
    p:not(:last-child) {
      margin-right: 16px;
    }
  }
}
</style>
